export const NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_LOADING =
  'NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_LOADING';
export const NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_LOAD_ERROR =
  'NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_LOAD_ERROR';
export const NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_GET_LETTERS =
  'NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_GET_REPORT';
export const NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_CLEAR_ERRORS =
  'NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_CLEAR_ERRORS';
export const NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_SET_LETTER_TYPE =
  'NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_SET_LETTER_TYPE';
export const NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_SET_STATUS_OPTION =
  'NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_SET_STATUS_OPTION';
export const NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_GET_BAD_EMAILS =
  'NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_GET_BAD_EMAILS';
export const NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_CLEAR_EMAILS_N =
  'NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_CLEAR_EMAILS_N';
export const NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_CLEAR_EMAILS_D =
  'NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_CLEAR_EMAILS_D';



// WEBPACK FOOTER //
// ./src/pages/notificationanddirectcertifiedletters/state/letter/types.js